import React, {useEffect, useState} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import { fetchAuditLogs } from '../../../redux/action'
import Pagination from "react-js-pagination";
import {CSVLink, CSVDownload} from "react-csv";
import moment from 'moment';
export default function AuditLogs() {
  const dispatch=useDispatch()
  const settings=useSelector((state)=>state.settings)
  //const dataToDownload=React.useRef([])
 const [dataToDownload,setDataToDownload]=useState([])
  const [activePage,setActivePage]=useState(1)
  const [filters,setFilters]=useState({
    start_date: "",
    end_date: "",
    keyword: "",
  })

  const updateTextInput=( target )=>{  
    filters[ target.name ] = target.value
    setFilters({...filters})
  }

  const GetDataToDownload=()=>{
    let Download = [];
    Download.push(["Log", "Responsible", "Time"])
    settings.audit_logs.forEach(element => {
      Download.push([element.log, element.responsible, element.created_at])
    });
    //dataToDownload.current=Download
    setDataToDownload(Download)
  }

  const getAuditLogs=(filters)=>{
   dispatch(fetchAuditLogs(filters))


  }
   useEffect(()=>{
     GetDataToDownload()
   },[settings.audit_logs])
  useEffect(()=>{
   getAuditLogs(filters)
   GetDataToDownload()
  },[])

  const handlePageChange=(pageNumber)=> {
    console.log(`active page is ${pageNumber}`);
    setActivePage(pageNumber);
  }
   
  return (
    <>
    
    <div className="row mt-5 main-section-scroll-height">
    <h1 className='filters'>Filters</h1>
            <div className="mt-4 d-flex ">
               
                <div style={{width:"20%",marginRight:"25px"}}>
                    <span style={{padding:"15px",color:"#999999"}}>Start Time</span>
                    <input onChange = {e => {updateTextInput(e.target); }} type="date" value={filters.start_date} name='start_date'  className="form-control slider-inputs mt-3 input-height-small" placeholder="Start Time"/>
                </div>
                <div style={{width:"20%",marginRight:"25px"}}>
                    <span style={{padding:"15px",color:"#999999"}}>End Time</span>
                    <input onChange = {e => { updateTextInput(e.target); }} type="date" value={filters.end_date} name='end_date'  className="form-control slider-inputs mt-3 input-height-small" placeholder="End Time"/>
                </div>
                <div style={{width:"25%"}}>
                <span style={{padding:"15px",color:"#999999"}}>Keyword or Phone Number</span>
                <input onChange = {e => { updateTextInput(e.target); }} type="text" name="keyword" value={filters.keyword}  className="form-control slider-inputs mt-3 input-height-small" placeholder="Keyword or Phone Number"/>
                 </div>

                 <div>
                 <span style={{padding:"15px"}}></span>
                 <button style={{marginTop:"40px"}} className="slider-success-btn" onClick={()=>getAuditLogs(filters)} >Go</button>
                 <button style={{marginTop:"40px",marginLeft:"10px"}} className="slider-success-btn">
                 <CSVLink filename="export.csv" data={dataToDownload} style={{color:'white'}}>Export</CSVLink>
                 </button>

                 </div>
                
            </div>

            <h1 className='filters mt-4'>Logs</h1>

            <table className="mt-2 table table-borderless">
                            <thead>
                                <tr>
                                  {/*  <th className="align-middle" style={{width:'10%'}} scope="col">ID</th>*/}
                                    <th className="align-middle" style={{width:'50%'}} scope="col">Log</th>
                                    <th className="align-middle" style={{width:'30%'}} scope="col">Responsible</th>
                                    <th className="align-middle" style={{width:'20%'}} scope="col">Time</th>
                                </tr>
                            </thead>
                            <tbody>
                              {settings.audit_logs.slice((activePage*5)-5,activePage*5).map((log)=>{
                                
                                return (
                                  <tr key={log.id}>
                                     <td className='align-middle'>{log.log}</td>
                                     <td className='align-middle'>{log.responsible}</td>
                                     <td className='align-middle'>{moment(log.created_at).format("MMMM Do YYYY, h:mm:ss a")}</td>

                                  </tr>
                                )

                              })}
                            </tbody>
               </table>

     
               <Pagination style={{width:"30px"}}
        activePage={activePage}
        itemsCountPerPage={5}
        totalItemsCount={settings.audit_logs.length}
        pageRangeDisplayed={1}
        onChange={handlePageChange}
      />
    </div>
  

      </>
  )
}